var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Message } from '../../store/message/message';
import httpService from '../../store/http-service';
var MessageService = (function () {
    function MessageService() {
        Object.defineProperty(this, "baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
    }
    Object.defineProperty(MessageService.prototype, "setBaseUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (url) {
            this.baseUrl = url;
            return this.baseUrl;
        }
    });
    Object.defineProperty(MessageService.prototype, "getMessages", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, entityType, entityId) {
            return __awaiter(this, void 0, void 0, function () {
                var messages;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, httpService.get(this.baseUrl + "/api/accounts/" + masterAccountId + "/conversations/" + entityType + "/" + entityId)];
                        case 1:
                            messages = _a.sent();
                            if (!messages) {
                                return [2, []];
                            }
                            return [2, messages.map(function (m) { return new Message(m); })];
                    }
                });
            });
        }
    });
    Object.defineProperty(MessageService.prototype, "sendMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, entityType, entityId, message, hasAttachment) {
            return __awaiter(this, void 0, void 0, function () {
                var content;
                return __generator(this, function (_a) {
                    content = {
                        message: message,
                        hasAttachment: hasAttachment
                    };
                    return [2, httpService.postWithResult(this.baseUrl + "/api/accounts/" + masterAccountId + "/conversations/" + entityType + "/" + entityId + "/message", content)];
                });
            });
        }
    });
    Object.defineProperty(MessageService.prototype, "uploadFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, messageId, file) {
            return __awaiter(this, void 0, void 0, function () {
                var formData;
                return __generator(this, function (_a) {
                    formData = new FormData();
                    formData.append('file', file);
                    return [2, httpService.postAsForm(this.baseUrl + "/api/accounts/" + masterAccountId + "/conversations/messages/" + messageId + "/attachment", formData)];
                });
            });
        }
    });
    Object.defineProperty(MessageService.prototype, "getAttachment", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, blobId, filename) {
            return __awaiter(this, void 0, void 0, function () {
                var blobUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, httpService.download(this.baseUrl + "/api/accounts/" + masterAccountId + "/conversations/attachment/" + blobId)];
                        case 1:
                            blobUrl = _a.sent();
                            this.displaySaveAttachmentDialog(blobUrl, filename);
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(MessageService.prototype, "setLastReadMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, entityType, entityId, messageId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, httpService.post(this.baseUrl + "/api/accounts/" + masterAccountId + "/conversations/" + entityType + "/" + entityId + "/last-read-message", messageId)];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(MessageService.prototype, "displaySaveAttachmentDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (blobUrl, filename) {
            var saveAttachmentDialog = document.createElement('a');
            document.body.appendChild(saveAttachmentDialog);
            saveAttachmentDialog.href = blobUrl;
            saveAttachmentDialog.download = filename;
            saveAttachmentDialog.click();
            saveAttachmentDialog.remove();
        }
    });
    return MessageService;
}());
export { MessageService };
